<!-- MFITTで電波状況が悪くてAPIエラーになった場合 -->
<template>
  <ItemDialog ref="unexpectedError" image-type="alert">
    <template #content-area>
      <p class="text-center">
        正しく動作が完了しませんでした。もう一度お試しください。
      </p>
    </template>
    <template #button-area>
      <ItemButton
        label="閉じる"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogUnexpectedError",
  props: {
    closeButtonClicked: {
      type: Function,
      required: false,
      default: null,
    },
  },
  setup(props) {
    const unexpectedError = ref(null);

    const openDialog = () => {
      unexpectedError.value.open();
    };

    const closeDialog = () => {
      if (props.closeButtonClicked == null) {
        unexpectedError.value.close();
      } else {
        props.closeButtonClicked();
      }
    };

    return {
      unexpectedError,
      openDialog,
      closeDialog,
    };
  },
};
</script>
